module.exports = __webpack_public_path__ + "img/Romania GP3.d4ce0210.png";